module.exports = __webpack_public_path__ + "static/media/Sri Lanka - LK.71e0bb61.png";